import { render, staticRenderFns } from "./FormBootstrapAudience.vue?vue&type=template&id=13edff56&lang=pug"
import script from "./FormBootstrapAudience.vue?vue&type=script&lang=js"
export * from "./FormBootstrapAudience.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports